module.exports = __webpack_public_path__ + "static/media/mountainCave.9ebf8dda.png";